import {VuexActions, VuexMutations} from "@/types/store/VuexTypes";
import {GetterTree} from "vuex";
import {RSForm, RSFORM_MUTATION, RSFormActions, RSFormMutations} from "@/types/RSFormStore";

const namespaced = true;

const state: RSForm = {
  form: {
    company: "",
    name: "",
    phone: 0,
    email: "",
    jobTitle: "",
    ec1: "",
    ec2: "",
    ec3: "",
    ec4: "",
    ec5: "",
    budget: null,
    startDate: null,
    endDate: null,
    brand: "",
    note: "",
  },
};

const getters: GetterTree<RSForm, any> = {
  form: ({form}) => form,
};

const mutations: VuexMutations<RSFormMutations, RSForm> = {
  UPDATE_RSFORM: (store, form) => {
    store.form = {...store.form, ...form};
  },
  CLEAR(store): void {
    store.form = {
      company: "",
      name: "",
      phone: 0,
      email: "",
      jobTitle: "",
      ec1: "",
      ec2: "",
      ec3: "",
      ec4: "",
      ec5: "",
      budget: null,
      startDate: null,
      endDate: null,
      brand: "",
      note: "",
    };
  },
};

const actions: VuexActions<RSFormActions, RSForm, any> = {
  UPDATE_RSFORM: (context, form) => {
    context.commit(RSFORM_MUTATION.UPDATE_RSFORM, form);
  },
  CLEAR(context): void {
    context.commit(RSFORM_MUTATION.CLEAR);
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
